<form [formGroup]="createSetupForm" (ngSubmit)="createRider()" style="height: 100%;">
    <div class="custom_tab_body_master">
        <div style="padding-top: 1%;margin: 1%;">
            <fieldset class="field_set" id="security_fieldset">
                <div>
                    <legend class="legend">Personal Details</legend>
                    <div class="row">
                        <div class="col-md-10 col-sm-8 col-8">
                            <div class="row">
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field>
                                            <input formControlName="firstName" matInput type="text"
                                                placeholder="First Name" autocomplete="off" required />
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field>
                                            <input formControlName="lastName" matInput type="text"
                                                placeholder="Last Name" autocomplete="off" required />
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field>
                                            <input formControlName="mobileNo" matInput type="number"
                                                placeholder="Mobile No." autocomplete="off" required>
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field>
                                            <input formControlName="email" matInput type="text" placeholder="Email ID"
                                                autocomplete="off" required readonly="">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field>
                                            <input readonly matInput [matDatepicker]="pickerAdd"
                                                style="cursor: pointer;" [max]="today" (click)="pickerAdd.open()"
                                                placeholder="Date of Birth" formControlName="dob">
                                            <mat-datepicker-toggle matSuffix [for]="pickerAdd"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerAdd disabled={{freeze}}></mat-datepicker>
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field class="selectOption">
                                            <mat-select formControlName="education" placeholder="Education">
                                                <mat-option [value]="null"> None </mat-option>
                                                <mat-option *ngFor="let c of educationDetails" [value]="c">{{c}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2 col-sm-4 col-4">
                            <div class="col-md-12 col-sm-12 col-12" style="height: 98%;">
                                <input hidden type="file" #fileUploaderCamera
                                    (change)="handleFileInputCamera($event.target.files);$event.target.value=null;"
                                    accept="image/*" />
                                <mat-card class="contain_card_Mto" fxFlex="100">
                                    <div readonly class="previewData clearfix"
                                        style="margin-top: 6px;text-align: center;">
                                        <img class="previewDataImg" style="height: 90px;width: 100px;cursor: pointer;"
                                            src="{{uploadedSignURLSelfie}}"
                                            *ngIf="!savedRiderSelfieForEdit && uploadRiderSelfieDiv" alt=""
                                            class="zoomImage" (click)="imageClick(uploadedSignURLSelfie)" />

                                        <img [src]="savedRiderSelfieForEdit" alt="" *ngIf="savedRiderSelfieForEdit"
                                            style="height: 85px;width: 100px;cursor: pointer;" class="zoomImage"
                                            (click)="imageClick(savedRiderSelfieForEdit)" />
                                        <div class="previewControls"
                                            style="display: flex;justify-content: space-around;align-items: center;">

                                            <mat-icon class="mat-icon" *ngIf="!freeze"
                                                (click)="removeImgSelfie();">delete</mat-icon>
                                            <span>Selfie</span>
                                            <mat-icon class="mat-icon" *ngIf="!freeze"
                                                (click)="fileChooserAndroid('Camera');fileUploaderCamera.click();$event.target.value=null;">add_a_photo
                                            </mat-icon>
                                        </div>
                                    </div>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <div style="padding-top: 1%;margin: 1%;">
            <fieldset class="field_set" id="security_fieldset">
                <legend class="legend">Vehicle & DL Details</legend>
                <div>
                    <div class="row">
                        <div class="col-md-10 col-sm-8 col-8">
                            <div class="row">
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field>
                                            <input formControlName="vehicleName" matInput type="text"
                                                placeholder="Vehicle Name" autocomplete="off">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field>
                                            <input formControlName="vehicleType" matInput type="text"
                                                placeholder="Vehicle Type" autocomplete="off">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field>
                                            <input formControlName="vehicleNo" matInput type="text"
                                                placeholder="Vehicle No" autocomplete="off" required>
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                    <mat-card class="contain_card div_spacing">
                                        <mat-form-field>
                                            <input formControlName="riderDlNo" matInput type="text"
                                                placeholder="Driving License No" autocomplete="off">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2 col-sm-4 col-4">
                            <div class="col-md-12 col-sm-12 col-12" style="height: 98%;">
                                <input hidden type="file" #fileUploaderDl accept="image/*"
                                    (change)="handleFileInputDl($event.target.files);$event.target.value=null;" />
                                <mat-card class="contain_card_Mto" fxFlex="100">
                                    <div readonly class="previewData clearfix"
                                        style="margin-top: 4px;text-align: center;">
                                        <img class="previewDataImg" style="height: 46px;width: 100px;cursor: pointer;"
                                            src="{{uploadedSignURLDl}}" *ngIf="!savedDlFile && uploadDlDiv" alt=""
                                            class="zoomImage" (click)="imageClick(uploadedSignURLDl)" />

                                        <img [src]="savedDlFile" alt="" *ngIf="savedDlFile"
                                            style="height: 46px;width: 100px;cursor: pointer;" class="zoomImage"
                                            (click)="imageClick(savedDlFile)" />
                                        <div class="previewControls"
                                            style="display: flex;justify-content: space-around;align-items: center;">
                                            <mat-icon class="mat-icon" *ngIf="!freeze"
                                                (click)="removeImgDl();">delete</mat-icon>
                                            <span>DL</span>
                                            <mat-icon class="mat-icon" *ngIf="!freeze"
                                                (click)="fileChooserAndroid('Camera');fileUploaderDl.click();$event.target.value=null;">add_a_photo
                                            </mat-icon>
                                        </div>
                                    </div>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <div style="padding-top: 1%;margin: 1%;">
            <fieldset class="field_set" id="security_fieldset">
                <legend class="legend">Aadhaar Details</legend>
                <div>
                    <div class="row">
                        <div class="col-md-6 col-sm-12 col-12">
                            <mat-card class="contain_card div_spacing">
                                <mat-form-field>
                                    <input formControlName="aadhaarNo" matInput type="text" placeholder="Aadhaar No."
                                        autocomplete="off" required>
                                </mat-form-field>
                            </mat-card>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-6" style="height: 100%;">
                            <input hidden type="file" #fileUploader accept="image/*"
                                (change)="handleFileInput($event.target.files);$event.target.value=null;" />
                            <mat-card class="contain_card_Mto" fxFlex="100">
                                <div readonly class="previewData clearfix" style="margin-top: 6px;text-align: center;">
                                    <img class="previewDataImg" style="height: 90px;width: 150px;cursor: pointer;"
                                        src="{{uploadedSignURLAadhaar}}" *ngIf="!savedAddharFile && uploadAadharDiv"
                                        alt="" class="zoomImageLeft" (click)="imageClick(uploadedSignURLAadhaar)" />

                                    <img [src]="savedAddharFile" alt="" *ngIf="savedAddharFile"
                                        style="height: 90px;width: 150px;cursor: pointer;" class="zoomImageLeft"
                                        (click)="imageClick(savedAddharFile)" />
                                    <div class="previewControls"
                                        style="display: flex;justify-content: space-around;align-items: center;">
                                        <mat-icon class="mat-icon" *ngIf="!freeze"
                                            (click)="removeImgAadhar();">delete</mat-icon>
                                        <span>Aadhaar Front</span>
                                        <mat-icon class="mat-icon" *ngIf="!freeze"
                                            (click)="fileChooserAndroid('Camera');fileUploader.click();$event.target.value=null;">add_a_photo
                                        </mat-icon>
                                    </div>
                                </div>
                            </mat-card>
                        </div>

                        <div class="col-md-6 col-sm-6 col-6" style="height: 100%;">
                            <input hidden type="file" #fileUploaderAadharBack accept="image/*"
                                (change)="handleFileInputAadhaarBack($event.target.files);$event.target.value=null;" />
                            <mat-card class="contain_card_Mto" fxFlex="100">
                                <div readonly class="previewData clearfix" style="margin-top: 6px;text-align: center;">
                                    <img class="previewDataImg" style="height: 90px;width: 150px;cursor: pointer;"
                                        src="{{uploadedSignURLAadhaarBack}}"
                                        *ngIf="!savedAddharBackFile && uploadAadharBackDiv" alt="" class="zoomImage"
                                        (click)="imageClick(uploadedSignURLAadhaarBack)" />

                                    <img [src]="savedAddharBackFile" alt="" *ngIf="savedAddharBackFile"
                                        style="height: 90px;width: 150px;cursor: pointer;" class="zoomImage"
                                        (click)="imageClick(savedAddharBackFile)" />
                                    <div class="previewControls"
                                        style="display: flex;justify-content: space-around;align-items: center;">
                                        <mat-icon class="mat-icon" *ngIf="!freeze"
                                            (click)="removeImgAadhaarBack();">delete</mat-icon>
                                        <span>Aadhaar Back</span>
                                        <mat-icon class="mat-icon" *ngIf="!freeze"
                                            (click)="fileChooserAndroid('Camera');fileUploaderAadharBack.click();$event.target.value=null;">add_a_photo
                                        </mat-icon>
                                    </div>
                                </div>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <div style="padding-top: 1%;margin: 1%;">
            <fieldset class="field_set" id="security_fieldset">
                <legend class="legend">Payment Details</legend>
                <div>
                    <div class="row">
                        <div class="col-md-4 col-sm-12 col-12">
                            <mat-card class="contain_card div_spacing">
                                <mat-form-field>
                                    <input formControlName="upiId" matInput type="text" placeholder="Upi Id."
                                        autocomplete="off">
                                </mat-form-field>
                            </mat-card>
                        </div>
                        <div class="col-md-4 col-sm-6 col-6">
                            <mat-card class="contain_card div_spacing">
                                <mat-form-field>
                                    <input formControlName="accountNo" matInput type="text" placeholder="Account No."
                                        autocomplete="off">
                                </mat-form-field>
                            </mat-card>
                        </div>
                        <div class="col-md-4 col-sm-6 col-6">
                            <mat-card class="contain_card div_spacing">
                                <mat-form-field>
                                    <input formControlName="ifscCode" matInput type="text" placeholder="Ifsc code"
                                        autocomplete="off">
                                </mat-form-field>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <div class="col-md-12 col-12 col-12">
            <div class="control">
                <label class="checkbox1" style="display: inherit;" [ngClass]="isAnimate ? 'label1' : 'label2'">
                    <input type="checkbox" formControlName="check" [(ngModel)]="isAgreedTerms" [checked]="isRiderAgree"
                        style="width: 15px;height: 13px;" />
                    I agree to the
                    <button type="button"
                        style="border: none; padding: 0; color: blue;background-color: white;margin-top: -5px!important;"
                        (click)="openPrivacyPolicyDialog()">
                        <u>terms and conditions</u>
                    </button>
                </label>
            </div>
        </div>
    </div>

    <div class="custom_sticky_footer">
        <div fxFlex="100">
            <!-- <button id="btnn" style="float: left;" *ngIf="displayBackBtn" (click)="goBack()">
                <mat-icon class="footer_icon_style">arrow_back</mat-icon>
                <br>
                BACK
            </button> -->
            <button type="submit" id="btnn">
                <mat-icon class="footer_icon_style">save</mat-icon>
                <br>
                {{button}}
            </button>
        </div>
    </div>
</form>